





















































































import Super from "@/pv4-super-class"
import { Component } from "vue-property-decorator"

import DataStoreEditor from "@/components/DataStoreEditor.vue"
import ModalHeader from "@/components/ModalHeader.vue"
import { AxiosRequestConfig } from "axios"
import { isEmpty } from "lodash"
import { parseStringPromise } from "xml2js"

@Component({ components: { DataStoreEditor, ModalHeader } })
export default class TaskCreate extends Super {
  saved = true
  dataStore: any = {
    dataStoreExternalSourceURL: "",
    dataStoreExternalSourceHeaders: " ",
    dataStoreExternalSourceTTL: 0,
    dataStoreJSON: {}
  }
  useExternal = false
  dataStoreKey = ""
  dataStoreSecret = ""
  isJsonValid = false
  dataStoreDataType = ""
  dataStoreConfig: AxiosRequestConfig = {}

  setUnsaved(): void {
    this.saved = false
  }

  get formatHeader(): string {
    return `{"${this.dataStoreKey}": "${this.dataStoreSecret}"}`
  }

  get dataStoreName() {
    const TITLE = "Data Type: "
    if (isEmpty(this.dataStoreDataType)) {
      return `${TITLE}Empty`
    } else if (this.dataStoreDataType == 'application/json') {
      return `${TITLE}JSON`}
      else if (this.dataStoreDataType == 'application/xml'){
        return `${TITLE}XML`
    } else {
      return `${TITLE}${this.dataStoreDataType}`
    }
  }

  /**
   * Loads in data from an external URL then returns mesage to user if it has succeded or failed
   * @param dataStore - data store object
   * @param externalURL - external url
   * @param externalHeader - external header
   * 
   */
  loadExternalURL(): void {
    let config: AxiosRequestConfig = {}

    if (this.dataStoreKey && this.dataStoreSecret) {
      config = { headers: JSON.parse(this.formatHeader) }
    }

    this.http
      .get(this.dataStore.dataStoreExternalSourceURL, config) //gets raw data
      .then(val => (this.dataStoreDataType = val.headers["content-type"])) //checks data type
      .then(() => {
        if (this.dataStoreDataType == "application/json") {
          config = { ...config, responseType: "json" }
        }
        if (this.dataStoreDataType == "application/xml") {
          config = { ...config, responseType: "text" }
        }
        this.dataStoreConfig = config
      }) //Update Config file
      .then(() => {
        return this.http.get(this.dataStore.dataStoreExternalSourceURL, config)
        .then(val => val.data)
      }) //Get Data
      .then(data => {
        if (this.dataStoreDataType == "application/json") {
          return data
        }
        if (this.dataStoreDataType == "application/xml") {
          return parseStringPromise(data, { explicitArray: false, mergeAttrs: true })
            .then(val => val )
        }
      }) //if Data is xml, convert to json
      .then(val => this.dataStore.dataStoreJSON = val)//returns data
      .catch(error => {
        this.isJsonValid = false
        this.$buefy.toast.open({
          message: error,
          type: "is-danger",
          duration: 5000
        })
      }) //catch errors
  }

  /**
   * Create new task, send to API
   */
  save() {
    this.dataStore.dataStoreExternalSourceHeaders = JSON.stringify(this.dataStoreConfig)
    const data = {
      dataStoreEnabled: 0,
      eventID: this.eventId,
      ...this.dataStore
    }

    this.http
      .post(`/data-store?eventID=${this.eventId}`, data)
      .then(this.back)
      .catch(this.displayError)
  }

  /**
   * Return back, close modal
   */
  back() {
    this.$emit("close")
  }
}
